import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IAbstractView } from '@core/interfaces';
import { ScrollContainerPresenter } from './scroll-container.presenter';
import { IScrollContainerComponent, IScrollContainerPresenter } from './interfaces';

@Component({
  selector: 'app-scroll-container',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './scroll-container.component.html',
  styleUrls: ['./scroll-container.component.scss'],
  providers: [ScrollContainerPresenter],
})
export class ScrollContainerComponent 
  extends IAbstractView<IScrollContainerPresenter> 
  implements IScrollContainerComponent {
  
  @Input() direction = this.presenter.direction;
  @Input() size = this.presenter.size;
  @Input() showScrollable = this.presenter.showScrollable;

  constructor(presenter: ScrollContainerPresenter) {
    super(presenter);
  }
}
